'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckedButton = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _SecondaryButton2 = require('../SecondaryButton/SecondaryButton');

var _SecondaryButton3 = _interopRequireDefault(_SecondaryButton2);

var _CheckedButton = require('./CheckedButton.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckedButtonCore = (0, _glamorous2.default)(_SecondaryButton3.default)(_CheckedButton.defaultStyle, _CheckedButton.mapPropsAndThemeToStyle);

var CheckedButton = function CheckedButton(_ref) {
  var _ref$input = _ref.input,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      label = _ref.label,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['input', 'label']);
  return _react2.default.createElement(
    CheckedButtonCore,
    (0, _extends3.default)({
      onChange: onChange,
      value: value,
      onClick: function onClick() {
        onChange(!value);
      }
    }, rest),
    _react2.default.createElement(
      'div',
      { className: 'buttonFieldRow' },
      _react2.default.createElement(
        'div',
        { className: 'buttonFieldIcon' },
        _react2.default.createElement('i', { className: 'fa fa-circle-thin buttonCircle' }),
        value && _react2.default.createElement('i', { className: 'fa fa-check buttonCheck' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'buttonFieldTitle' },
        label
      )
    )
  );
};

exports.CheckedButton = CheckedButton;
CheckedButton.propTypes = {
  /*
    Carries a value and an onChange. Comes from redux-form's wrapper.
   */
  input: _propTypes2.default.object.isRequired,
  /*
    A label for the button.
   */
  label: _propTypes2.default.string
};

exports.default = CheckedButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/CheckedButton/CheckedButton.js
// module id = 346
// module chunks = 0